import type { CSSProperties, ReactNode } from 'react'
import { LoaderCircle } from 'lucide-react'

interface NoticeProps {
  title: ReactNode
  children?: ReactNode
  body?: ReactNode
  action?: ReactNode
  tone?: string
  style?: CSSProperties
}

export function Notice({
  title,
  children,
  body,
  action,
  tone = 'info',
  style,
}: NoticeProps) {
  const colors =
    tone === 'error'
      ? 'border-red-200 bg-red-50 text-red-800'
      : tone === 'warning'
        ? 'border-amber-200 bg-amber-50 text-amber-900'
        : 'border-violet-200 bg-violet-50 text-slate-800'
  return (
    <section
      role={tone === 'error' ? 'alert' : 'status'}
      style={style}
      className={`mb-4 flex flex-wrap items-start justify-between gap-3 rounded-xl border p-4 text-sm ${colors}`}
    >
      <div className="min-w-0 flex-1">
        <div className="font-medium">{title}</div>
        {(body || children) && (
          <div className="mt-1 leading-relaxed">{body || children}</div>
        )}
      </div>
      {action}
    </section>
  )
}

export function Spinner() {
  return (
    <span role="status" aria-label="載入中" className="flex justify-center p-8">
      <LoaderCircle className="size-6 animate-spin text-primary" />
    </span>
  )
}
